import React from 'react';
import { ReactComponent as DownloadIcon } from "assets/img/svg/downloadBlackV2.svg";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";

const CustomDownload = ({
    fileData,
    onClick = () => { },
    isAvailable,
}) => {
    return (
        <>
            {
                fileData?.length ? (
                    <div>
                        <AButton
                            onClick={onClick}
                            variant='outline'
                            outlineVariantColor='#CCC'
                            textColor='#0F0F0F'
                            size='sm'
                        >
                            <div className='d-flex align-items-center gap-md'>
                                <DownloadIcon className='icon ml-2 cursor'
                                     style={{
                                    width: "22px",
                                    height: "20px",
                                    // backgroundColor: "#00aeef",
                                    // borderColor: "#00aeef",
                                    // padding: "5px",
                                }} 
                                />
                                Download
                            </div>
                        </AButton>
                    </div>
                ) : ("No Download Available")
            }

        </>


    );
};

export default CustomDownload;
